import { render, staticRenderFns } from "./Legalitas.vue?vue&type=template&id=7ebf4197&"
import script from "./Legalitas.vue?vue&type=script&lang=js&"
export * from "./Legalitas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports